// @flow
import type {Node} from 'react'
import React, {Component} from 'react'
import {values} from 'ramda'

import MoveItems from '../../ui/Summary/MoveItems'
import type {MoveItemsProps} from '../../ui/Summary/MoveItems'
import listHasChanges from '../../ui/Summary/listHasChanges'
import SummaryUI from '../../ui/Summary'
import Item from '../../Item'

type Props = MoveItemsProps & {changeKey: string}

class Summary extends Component<Props> {
  get hasChanges(): boolean {
    return (
      listHasChanges(this.rolesUp)
      || listHasChanges(this.rolesDown)
      || listHasChanges(this.policiesUp)
      || listHasChanges(this.policiesDown)
    )
  }

  get rolesUp(): Item[] {
    return values(this.props.rolesToMoveUp)
  }

  get rolesDown(): Item[] {
    return values(this.props.rolesToMoveDown)
  }

  get policiesUp(): Item[] {
    return values(this.props.policiesToMoveUp)
  }

  get policiesDown(): Item[] {
    return values(this.props.policiesToMoveDown)
  }

  renderContent(): null | Node {
    if (!this.hasChanges)
      return null

    return (
      <MoveItems
        changeKey={this.props.changeKey}
        rolesToMoveUp={this.rolesUp}
        rolesToMoveDown={this.rolesDown}
        policiesToMoveUp={this.policiesUp}
        policiesToMoveDown={this.policiesDown}
      />
    )
  }

  render(): Node {
    return (
      <SummaryUI>
        {this.renderContent()}
      </SummaryUI>
    )
  }
}

export default Summary
